import { ValueOf } from '../utilities/types';

const reportTypes = {
  ACCOUNT_FIRST_INITIATOR: 'accountFirstInitiator',
  BUSINESS_USAGE_REPORT: 'businessUsageReport',
  CASE_OVERVIEW: 'caseOverview',
  CASE_STATUS_HISTORY_REPORT: 'caseStatusHistoryReport',
  CASE_PDF: 'casePdf',
  CUSTOM: 'custom',
  ENTITY_OVERVIEW: 'entityOverview',
  ENTITY_REPORT: 'entityReport',
  ENTITY_TRANSACTIONS: 'entityTransactions',
  EXTENDED_TRANSACTIONS: 'extendedTransactions',
  FIPO: 'fipo',
  GROUP_DURATION: 'groupDuration',
  KRI_REPORT: 'kriReport',
  PEP_SANCTION_HITS_THRESHOLD_VARIATION: 'pepSanctionHitsThresholdVariation',
  PORTFOLIO_SCREENING_REPORT: 'portfolioScreeningReport',
  PING_OVERVIEW: 'pingOverview',
  REQUEST_OVERVIEW: 'requestOverview',
  RULE_OVERVIEW: 'ruleOverview',
  RULE_STATISTICS: 'ruleStatistics',
  RULE_THRESHOLD_VARIATION: 'ruleThresholdVariation',
} as const;
export type ReportTypes = ValueOf<typeof reportTypes>;

export const reportNames: Record<ReportTypes, string> = {
  [reportTypes.ACCOUNT_FIRST_INITIATOR]: 'Transacting accounts',
  [reportTypes.BUSINESS_USAGE_REPORT]: 'Business usage',
  [reportTypes.CASE_OVERVIEW]: 'Case overview',
  [reportTypes.CASE_STATUS_HISTORY_REPORT]: 'Case Status History',
  [reportTypes.CASE_PDF]: 'Case PDF',
  [reportTypes.CUSTOM]: 'Custom report',
  [reportTypes.ENTITY_OVERVIEW]: 'Entity overview',
  [reportTypes.ENTITY_REPORT]: 'Entity report',
  [reportTypes.ENTITY_TRANSACTIONS]: 'Entity transactions',
  [reportTypes.EXTENDED_TRANSACTIONS]: 'Extended transactions',
  [reportTypes.FIPO]: 'FIPO',
  [reportTypes.GROUP_DURATION]: 'Group duration',
  [reportTypes.KRI_REPORT]: 'KRI report',
  [reportTypes.PEP_SANCTION_HITS_THRESHOLD_VARIATION]: 'Pep & Sanction hits',
  [reportTypes.PORTFOLIO_SCREENING_REPORT]: 'Portfolio screening',
  [reportTypes.PING_OVERVIEW]: 'Ping overview',
  [reportTypes.REQUEST_OVERVIEW]: 'Request overview',
  [reportTypes.RULE_OVERVIEW]: 'Rule overview',
  [reportTypes.RULE_STATISTICS]: 'Rule statistics',
  [reportTypes.RULE_THRESHOLD_VARIATION]: 'Rule threshold variation',
};

export const reportTypesChoices = [
  reportTypes.ACCOUNT_FIRST_INITIATOR,
  reportTypes.BUSINESS_USAGE_REPORT,
  reportTypes.CASE_OVERVIEW,
  reportTypes.CASE_STATUS_HISTORY_REPORT,
  reportTypes.ENTITY_OVERVIEW,
  reportTypes.ENTITY_TRANSACTIONS,
  reportTypes.EXTENDED_TRANSACTIONS,
  reportTypes.GROUP_DURATION,
  reportTypes.KRI_REPORT,
  reportTypes.PEP_SANCTION_HITS_THRESHOLD_VARIATION,
  reportTypes.PORTFOLIO_SCREENING_REPORT,
  reportTypes.PING_OVERVIEW,
  reportTypes.REQUEST_OVERVIEW,
  reportTypes.RULE_OVERVIEW,
  reportTypes.RULE_STATISTICS,
  reportTypes.RULE_THRESHOLD_VARIATION,
].map((id) => ({ id, name: reportNames[id] }));

export const reportTypesDisplayChoices = [
  reportTypes.ACCOUNT_FIRST_INITIATOR,
  reportTypes.BUSINESS_USAGE_REPORT,
  reportTypes.CASE_OVERVIEW,
  reportTypes.CASE_STATUS_HISTORY_REPORT,
  reportTypes.CASE_PDF,
  reportTypes.CUSTOM,
  reportTypes.ENTITY_OVERVIEW,
  reportTypes.ENTITY_REPORT,
  reportTypes.ENTITY_TRANSACTIONS,
  reportTypes.EXTENDED_TRANSACTIONS,
  reportTypes.FIPO,
  reportTypes.GROUP_DURATION,
  reportTypes.KRI_REPORT,
  reportTypes.PEP_SANCTION_HITS_THRESHOLD_VARIATION,
  reportTypes.PORTFOLIO_SCREENING_REPORT,
  reportTypes.PING_OVERVIEW,
  reportTypes.REQUEST_OVERVIEW,
  reportTypes.RULE_OVERVIEW,
  reportTypes.RULE_STATISTICS,
  reportTypes.RULE_THRESHOLD_VARIATION,
].map((id) => ({ id, name: reportNames[id] }));

export type SelectableReportTypes = typeof reportTypesChoices[number]['id'];

export default reportTypes;
